import(/* webpackMode: "eager", webpackExports: ["NewsArticle"] */ "/home/runner/work/baysgaia-site/baysgaia-site/src/components/organisms/level3/NewsArticle/NewsArticle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Level3Layout","default"] */ "/home/runner/work/baysgaia-site/baysgaia-site/src/components/templates/Level3Layout/Level3Layout.tsx");
